import React from 'react'
import ImageTextSection from '../components/auth/ImageTextSection'
import signInImage from '../assets/signInIllustration.png'
import VerticalDivider from '../components/auth/VerticalDivider'
import OuterContainer from '../components/auth/OuterContainer'
import MiddleContainer from '../components/auth/MiddleContainer'
import InnerContainer from '../components/auth/InnerContainer'
import LoginSection from '../components/auth/LoginSection'

const LoginScreen = () => {
  return (
    <OuterContainer>
      <MiddleContainer>
        <InnerContainer>
          {/* illustration section */}
          <ImageTextSection imagePath={signInImage} />

          {/* Vertical Line */}
          <VerticalDivider />

          {/* Login and input section */}
          <LoginSection />
        </InnerContainer>
      </MiddleContainer>
    </OuterContainer>
  )
}

export default LoginScreen
